import pre from './pre';
import post from './post';
import cart from './cart.vue';
import config from './config/index.vue';
import success from './success.vue'

export default {
    pre,
    currencyFilter: ['INR'],
    components: {
        config,
        cart,
        success
    },
    post,
}
